export default __webpack_public_path__ + "static/media/frontend.82eda83a.svg";